/**
 * Item.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

export default {

  // tableName: 'mercancias',

  display: 'type',

  attributes: {

    pictures: {
      type: 'file'
    },

    //  ╔═╗╔═╗╔═╗╔═╗╔═╗╦╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
    //  ╠═╣╚═╗╚═╗║ ║║  ║╠═╣ ║ ║║ ║║║║╚═╗
    //  ╩ ╩╚═╝╚═╝╚═╝╚═╝╩╩ ╩ ╩ ╩╚═╝╝╚╝╚═╝

    description: {
      type: 'string',
      columnType: 'text',
      required: true,
      // columnName: 'tipo_mercancia_id'
    },

    //  ╔═╗╦═╗╦╔╦╗╦╔╦╗╦╦  ╦╔═╗╔═╗
    //  ╠═╝╠╦╝║║║║║ ║ ║╚╗╔╝║╣ ╚═╗
    //  ╩  ╩╚═╩╩ ╩╩ ╩ ╩ ╚╝ ╚═╝╚═╝

    damaged: {
      type: 'boolean',
      defaultsTo: false,
      // columnName: 'dañado'
    },

    weight: {
      type: 'string',
      allowNull: true,
      // columnName: 'volumen_peso'
    },

    packages: {
      type: 'string',
      allowNull: true,
      // columnName: 'bultos'

    },

    value: {
      type: 'string',
      allowNull: true,
      // columnName: 'valor_declarado'
    },

    materialCode: {
      type: 'string',
      allowNull: true,
      // columnName: 'valor_declarado'
    },

    satCode: {
      type: 'string',
      allowNull: true,
      // columnName: 'valor_declarado'
    },

    htsCode: {
      type: 'string',
      allowNull: true,
      // columnName: 'valor_declarado'
    },

    productType: {
      type: 'string',
      allowNull: true,
    },

    hazmat: {
      type: 'boolean',
      allowNull: true,
    },

    hazmatCode: {
      type: 'string',
      columnType: 'text',
      allowNull: true,
    },

    packaging: {
      type: 'string',
      columnType: 'text',
      allowNull: true,
    },

    packagingDescription: {
      type: 'string',
      columnType: 'text',
      allowNull: true,
    },

    //  ╔═╗╔╦╗╔╗ ╔═╗╔╦╗╔═╗
    //  ║╣ ║║║╠╩╗║╣  ║║╚═╗
    //  ╚═╝╩ ╩╚═╝╚═╝═╩╝╚═╝


    //  ╔═╗╔═╗╔═╗╔═╗╔═╗╦╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
    //  ╠═╣╚═╗╚═╗║ ║║  ║╠═╣ ║ ║║ ║║║║╚═╗
    //  ╩ ╩╚═╝╚═╝╚═╝╚═╝╩╩ ╩ ╩ ╩╚═╝╝╚╝╚═╝

    type: {
      model: 'itemtype',
      required: false,
      // columnName: 'tipo_mercancia_id'
    },

    dispatch: {
      model: 'dispatch',
      // columnName: 'viaje_id'
    }

  },

}



// WEBPACK FOOTER //
// ./src/models/Item.js